import { Component, OnDestroy, OnInit, signal } from '@angular/core';
import { EMPTY, Subject, debounceTime, filter, startWith, switchMap, takeUntil } from 'rxjs';
import { AuthService } from 'src/auth/services/auth.service';
import {
  AdminClient,
  AuthClient,
  AvailableEdOrgDto,
  EdOrgRoleSelectionDto,
  RoleDto,
} from 'src/shared/services/api.service';
import { RouteTypeService } from 'src/shared/services/route-type.service';

@Component({
  selector: 'cert-entity-configurator',
  templateUrl: './entity-configurator.component.html',
  styles: ``,
  standalone: false,
})
export class EntityConfiguratorComponent implements OnInit, OnDestroy {
  roles = signal<RoleDto[]>([]);
  searchTerm$ = new Subject<string>();
  edOrgs = signal<AvailableEdOrgDto[]>([]);
  testEmail!: string;

  selectedRoleIds: number[] = [];

  defaultEdOrg: AvailableEdOrgDto = {
    edOrgId: 79275,
    edOrgName: 'Arizona Department of Education',
  };

  userEdOrgs: EdOrgRoleSelectionDto[] = [
    {
      edOrgId: this.defaultEdOrg.edOrgId,
      roleIds: [],
    },
  ];

  minLengthTerm = 3;
  private unsubscribe$ = new Subject<void>();

  constructor(
    private readonly authService: AuthService,
    private readonly adminClient: AdminClient,
    private readonly authClient: AuthClient,
    private readonly routeTypeService: RouteTypeService,
  ) {}

  ngOnInit(): void {
    this.authService
      .isLoggedIn()
      .pipe(
        switchMap((isLoggedIn) => {
          if (isLoggedIn) {
            return this.routeTypeService.navigateToUserHomePage();
          } else {
            this.adminClient
              .getRoles()
              .pipe(takeUntil(this.unsubscribe$))
              .subscribe((x) => this.roles.set(x));

            this.searchTerm$
              .pipe(
                filter((searchTerm) => {
                  return searchTerm !== null && searchTerm.length >= this.minLengthTerm;
                }),
                debounceTime(300), // wait for 300ms pause in typing
                switchMap((searchTerm) => this.authClient.getEdOrgs({ edOrgNameSearch: searchTerm })),
                startWith([this.defaultEdOrg]),
                takeUntil(this.unsubscribe$),
              )
              .subscribe((x) => this.edOrgs.set(x));

            return EMPTY;
          }
        }),
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  onAddEdOrg() {
    this.userEdOrgs.push({
      edOrgId: -1,
      roleIds: [],
    });
  }

  onLogin() {
    this.authService
      .completeTestLogin(this.testEmail, this.userEdOrgs)
      .pipe(
        switchMap((policySet) => {
          // if we have a policy set, we're good to go.
          return policySet ? this.routeTypeService.navigateToUserHomePage() : EMPTY;
        }),
      )
      .subscribe();
  }
}
